import React, { useEffect } from 'react';
import {
  Box,
  Container,
  Grid,
  makeStyles, Typography
} from '@material-ui/core';
import { useParams, Navigate } from 'react-router';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import { store } from '../../../redux/store';
import ProductCard from './ProductCard';
import CategoryApi from '../../../utils/apiManager/constrollers/categoryApi';
import { getImages } from '../../../redux/reducers/images/selectors';
import { addImages } from '../../../redux/reducers/images/actions';
import { setLastUsedGroup } from '../../../redux/reducers/groups/actions';
import { setLastUsedCategory } from '../../../redux/reducers/categories/actions';
import UploadImageTemplateCard from './UploadImageTemplateCard';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    padding: '0',
  },
  cardsbox: {
    marginTop: '25px'
  },
  textInfo: {
    textAlign: 'center',
    fontSize: '40px',
    color: '#000000'
  },
  productCard: {
    width: '100%',
    height: '100%',
  },
  cardItem: {
    width: '280px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      margin: '0 20px 0 20px'
    }
  }
}));

const ProductList = (props) => {
  const classes = useStyles();
  const { groupId, categoryId } = useParams();
  const catId = categoryId || props.lastUsedCategoryId;

  useEffect(() => {
    const fetchItems = async () => {
      const categoryApi = await CategoryApi.getInstance();
      const data = await categoryApi.fetchItems(catId);
      props.addImages({
        id: catId,
        images: data || [],
      });
    };

    if (catId) {
      props.setLastUsedGroup(groupId);
      props.setLastUsedCategory(catId);
      fetchItems(catId);
    } else {
      props.addImages({
        id: null,
        images: [],
      });
    }
  }, [catId]);

  const render = (
    <Page
      className={classes.root}
      title="Products"
    >
      <Container maxWidth={false}>
        <Box
          mt={12}
          className={classes.cardsbox}
        >
          <Grid
            container
            spacing={3}
            flex-wrap="wrap"
            justify-content="space-evenly"
          >
            {
              categoryId
                ? (
                  <Grid
                    item
                    key='default'
                    className={classes.cardItem}
                  >
                    <UploadImageTemplateCard categoryId={categoryId} />
                  </Grid>
                )
                : (
                  <Typography
                    className={classes.textInfo}
                  >
                    Add category to upload images
                  </Typography>
                )
            }
            {props.images.map((product, index) => (
              <Grid
                item
                key={product.id || product.fileId}
                className={classes.cardItem}
              >
                <ProductCard
                  index={index}
                  className={classes.productCard}
                  product={product}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Page>
  );

  if (!categoryId) {
    const { lastUsedGroupId } = store.getState().root.groupsStore;
    if (props.lastUsedCategoryId && lastUsedGroupId) {
      return <Navigate to={`/app/dashboard/${lastUsedGroupId}/${props.lastUsedCategoryId}`}/>;
    }
    return render;
  } else {
    return render;
  }
};

export default connect(
  getImages,
  {
    addImages,
    setLastUsedCategory,
    setLastUsedGroup,
  }
)(ProductList);
